import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function use_subdomain() {
  return request({
    url: global.endpoint.USE_SUBDOMAIN,
    method: "get",
  });
}

async function toggle_use_subdomain(data) {
  return request({
    url: global.endpoint.USE_SUBDOMAIN,
    method: "put",
    data
  });
}

async function get_subdomains(params) {
  return request({
    url: global.endpoint.SUBDOMAINS,
    method: "get",
    params
  });
}

async function create_subdomain(data) {
  return request({
    url: global.endpoint.SUBDOMAINS,
    method: "post",
    data
  });
}

async function update_subdomain(id, data) {
  return request({
    url: global.endpoint.SUBDOMAIN.replace(':id', id),
    method: "put",
    data
  });
}

async function get_addresses(params) {
  return request({
    url: global.endpoint.ADDRESSES,
    method: "get",
    params
  });
}

async function create_address() {
  return request({
    url: global.endpoint.ADDRESSES,
    method: "post",
  });
}

async function update_address(id, data) {
  return request({
    url: global.endpoint.ADDRESS.replace(':id', id),
    method: "put",
    data
  });
}

async function delete_address(id, data) {
  return request({
    url: global.endpoint.ADDRESS.replace(':id', id),
    method: "delete",
  });
}

export default {
  use_subdomain,
  toggle_use_subdomain,
  get_subdomains,
  create_subdomain,
  update_subdomain,
  get_addresses,
  create_address,
  update_address,
  delete_address
};
